/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @atlaskit/ui-styling-standard/no-global-styles
import { css, Global, jsx } from '@emotion/react';
var extensionStyles = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
  '[extensionkey="synced-block:reference"] .ak-renderer-wrapper > div:last-of-type': {
    padding: "var(--ds-space-250, 20px)",
    paddingRight: "var(--ds-space-250, 20px)"
  }
});
export var GlobalStylesWrapper = function GlobalStylesWrapper() {
  return jsx(Global, {
    styles: [extensionStyles]
  });
};